<template lang="pug">
  .b2b-table-planned_processes
    ods-table(
      :data='plannedProcesses.tableData',
      style='width: 100%',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='group',
        :label='$t("plannedProcesses.plannedProcesses_table.group")',
        :show-overflow-tooltip='true',
        v-if='isShowPlannedProcessesGroup',
        min-width='180',
        sortable='')
      ods-table-column(
        prop='name',
        :label='$t("plannedProcesses.plannedProcesses_table.name")',
        :show-overflow-tooltip='true',
        v-if='isShowPlannedProcessesName',
        min-width='100',
        sortable='')
      ods-table-column(
        prop='description',
        :label='$t("plannedProcesses.plannedProcesses_table.description")',
        :show-overflow-tooltip='true',
        v-if='isShowPlannedProcessesDescription',
        min-width='100',
        sortable='')
      ods-table-column(
        prop='status',
        :formatter='formatterStatusJob'
        :label='$t("plannedProcesses.plannedProcesses_table.status")',
        :show-overflow-tooltip='true',
        v-if='isShowPlannedProcessesStatus',
        min-width='100',
        sortable='')
      ods-table-column(
        prop='jobClass',
        :label='$t("plannedProcesses.plannedProcesses_table.jobclass")',
        :show-overflow-tooltip='true',
        v-if='isShowPlannedProcessesJobClass',
        min-width='100',
        sortable='')
      ods-table-column(
        prop='triggerCron',
        :label='$t("plannedProcesses.plannedProcesses_table.triggerCron")',
        :show-overflow-tooltip='true',
        v-if='isShowPlannedProcessesTriggerCron',
        min-width='100',
        :render-header="renderHeader"
        sortable='')
      ods-table-column(
        v-if='canAdminQuartz'
        label,
        :render-header='renderHeaderActions',
        width='115')
        template(slot-scope='scope')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('plannedProcesses.plannedProcesses_button.resume') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              icon-position='left'
              @click='handleGoResume(scope.row)')
              ods-icon(name='play', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('plannedProcesses.plannedProcesses_button.pause') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoPause(scope.row)')
              ods-icon(name='disable', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('plannedProcesses.plannedProcesses_button.interrupt') }}
            ods-button(
              style=' padding-left: 10px; padding-right: 0px;'
              type='neutral',
              icon-position='right'
              @click='handleGoInterrupt(scope.row)')
              ods-icon(name='fire', size='16')
    ods-row.b2b-table-planned_processes__classrow( v-if='canAdminQuartz' )
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.refresh_tooltip")', placement='bottom')
          ods-button(
            style='float:left',
            icon='ods-icon-refresh',
            size='medium',
            circle,
            @click="getAllPlanedProcessed")
        ods-tooltip(:content='$t("plannedProcesses.plannedProcesses_button.pauseAll_tooltip")', placement='bottom')
          ods-button(
            style='float:right',
            type='primary',
            @click.native='handleGoPauseAll()')
            | {{ $t('plannedProcesses.plannedProcesses_button.pauseAll') }}
        ods-tooltip(:content='$t("plannedProcesses.plannedProcesses_button.resumeAll_tooltip")', placement='bottom')
          ods-button(
            style='float:right',
            type='primary',
            @click.native='handleGoResumeAll()')
            | {{ $t('plannedProcesses.plannedProcesses_button.resumeAll') }}
        ods-tooltip(:content='$t("plannedProcesses.plannedProcesses_button.standby_tooltip")', placement='bottom')
          ods-button(
            style='float:right',
            type='primary',
            @click.native='handleGoStandby()')
            | {{ $t('plannedProcesses.plannedProcesses_button.standby') }}
        ods-tooltip(:content='$t("plannedProcesses.plannedProcesses_button.start_tooltip")', placement='bottom')
          ods-button(
            style='float:right',
            type='primary',
            @click.native='handleGoStart()')
            | {{ $t('plannedProcesses.plannedProcesses_button.start') }}
        ods-tooltip(:content='$t("plannedProcesses.plannedProcesses_button.shutdown_tooltip")', placement='bottom')
          ods-button(
            style='float:right',
            type='primary',
            @click.native='handleGoShutdown()')
            | {{ $t('plannedProcesses.plannedProcesses_button.shutdown') }}

    //- Servicios Seleccionados
    transition(
      name='slide',
      mode='out-in')
      b2b-table-select-rows(
        v-if='multipleSelection.length',
        :total-select='multipleSelection.length')

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import B2bTableMenuPlannedProcesses from '@/views/administracion/plannedProcesses/B2bTableMenuPlannedProcesses'

export default {
  name: 'b2b-table-planned_processes',
  mixins: [Utils],
  data () {
    return {
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: []
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'plannedProcesses',
      'queryPlannedProcesses',
      'isShowPlannedProcessesGroup',
      'isShowPlannedProcessesName',
      'isShowPlannedProcessesDescription',
      'isShowPlannedProcessesStatus',
      'isShowPlannedProcessesJobClass',
      'isShowPlannedProcessesTriggerCron',
      // Permisos
      'canAdminQuartz',
      'primaryColor'
    ])
  },

  components: {
    B2bTableSelectRows,
    B2bTableMenuPlannedProcesses
  },

  methods: {
    ...mapActions([
      'queryPlannedProcessesState',
      'getPlannedProcesses',
      'pauseJob',
      'resumeJob',
      'interruptJob',
      'pauseAll',
      'resumeAll',
      'shutdown',
      'standby',
      'start'
    ]),

    /* Ordenar Tabla */
    async orderOnServer ({ column, order, prop }) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })
      try {
        let stringSort = ''
        const dataQuery = {
          query: {}
        }

        if (order === 'descending') {
          order = 'DESC'
        } else if (order === 'ascending') {
          order = 'ASC'
        } else {
          order = 'ASC'
        }

        if (!prop) {
          prop = 'mailType'
        }
        stringSort = prop + ',' + order
        this.queryPlannedProcesses.sort = stringSort
        await this.queryPlannedProcessesState(this.queryPlannedProcesses)
        dataQuery.query = this.queryPlannedProcesses
        await this.getPlannedProcesses(dataQuery)
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    async handleGoPause (rowSelected) {
      console.log('Pause job:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const request = { name: rowSelected.name, group: rowSelected.group }
        await this.pauseJob(request)

        const dataQuery = { query: {} }
        dataQuery.query = this.queryPlannedProcesses
        await this.getPlannedProcesses(dataQuery)

        this.$notify({
          title: this.$t('msg_generics.request_success'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleGoResume (rowSelected) {
      console.log('Resume job:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const request = { name: rowSelected.name, group: rowSelected.group }
        await this.resumeJob(request)

        const dataQuery = { query: {} }
        dataQuery.query = this.queryPlannedProcesses
        await this.getPlannedProcesses(dataQuery)

        this.$notify({
          title: this.$t('msg_generics.request_success'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleGoInterrupt (rowSelected) {
      console.log('Interrupt job:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const request = { name: rowSelected.name, group: rowSelected.group }
        await this.interruptJob(request)

        const dataQuery = { query: {} }
        dataQuery.query = this.queryPlannedProcesses
        await this.getPlannedProcesses(dataQuery)

        this.$notify({
          title: this.$t('msg_generics.request_success'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    /* Todos los jobs */
    async handleGoShutdown () {
      console.log('shutdown job:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.shutdown()

        const dataQuery = { query: {} }
        dataQuery.query = this.queryPlannedProcesses
        await this.getPlannedProcesses(dataQuery)

        this.$notify({
          title: this.$t('msg_generics.request_success'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleGoStart () {
      console.log('start job:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.start()

        const dataQuery = { query: {} }
        dataQuery.query = this.queryPlannedProcesses
        await this.getPlannedProcesses(dataQuery)

        this.$notify({
          title: this.$t('msg_generics.request_success'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleGoStandby () {
      console.log('standby job:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.standby()

        const dataQuery = { query: {} }
        dataQuery.query = this.queryPlannedProcesses
        await this.getPlannedProcesses(dataQuery)

        this.$notify({
          title: this.$t('msg_generics.request_success'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleGoResumeAll () {
      console.log('reusmeall job:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.resumeAll()

        const dataQuery = { query: {} }
        dataQuery.query = this.queryPlannedProcesses
        await this.getPlannedProcesses(dataQuery)

        this.$notify({
          title: this.$t('msg_generics.request_success'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleGoPauseAll () {
      console.log('Pause all:...')
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.pauseAll()

        const dataQuery = { query: {} }
        dataQuery.query = this.queryPlannedProcesses
        await this.getPlannedProcesses(dataQuery)

        this.$notify({
          title: this.$t('msg_generics.request_success'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuPlannedProcesses/>
    },

    renderHeader (h, { column }) {
      const triggerCron = [
        h('div', { slot: 'content', style: 'margin-bottom:5px' }, this.$t('plannedProcesses.text1')),
        h('div', { slot: 'content' }, this.$t('plannedProcesses.text2')),
        h('div', { slot: 'content' }, this.$t('plannedProcesses.text3')),
        h('div', { slot: 'content' }, this.$t('plannedProcesses.text4')),
        h('div', { slot: 'content' }, this.$t('plannedProcesses.text5'))
      ]
      return h('div', { class: 'd_icon' }, [
        h('span', column.label),
        h('ods-tooltip', { class: 'custom', props: { placement: 'left' } },
          [
            triggerCron,
            h('i', { class: 'ods-icon-info', style: 'font-size: 14px;margin-left: 5px !important;' })
          ]
        )
      ])
    },

    async getAllPlanedProcessed () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        const dataQuery = {
          query: {}
        }
        dataQuery.query = this.queryPlannedProcesses
        await this.getPlannedProcesses(dataQuery)
      } catch (error) {
        console.log('getUsers CATCH: ', error)
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      if (val.length === 0) {
        this.multipleSelection = []
      }
      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
    },

    formatterStatusJob (row, column) {
      return this.$t('job_status.' + row.status)
    },
    async getNotificationErrorMessage (error) {
      const statusCode = error.status
      let errorSmsList = []
      let errorSms = ''
      let errorArgList = []

      if (error.data) {
        errorArgList = error.data.errorArgList
        errorSmsList = error.data.messageList
      }

      switch (statusCode) {
        case 400:

          if (error.data.message && error.data.message !== null && errorArgList === null && (errorSmsList === null || typeof errorSmsList === 'undefined')) {
            errorSms = error.data.message
            break
          } else if (error.request) {
            if (error.request.response) {
              errorSmsList = error.request.response
            } else if (error.request.responseText) {
              errorSmsList = error.request.responseText
            }
            if (error.data.messageList !== undefined) {
              error.data.messageList = errorSmsList
            }
            break
          } else if (errorArgList === null && typeof errorSmsList === 'undefined') {
            errorSms = 'error.e400_create_invoice'
            break
          } else {
            break
          }

        case 401:
          errorSms = 'error.e401'
          break
        case 403:
          errorSms = 'error.e403'
          break
        case 409:
          errorSms = 'error.e409_create_invoice'
          break
        case 500:
          errorSms = 'error.e500'
          break
        default:
          errorSms = 'error.default'
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    await this.getAllPlanedProcessed()
  }
}

</script>

<style lang="scss" scoped>
.b2b-table-planned_processes {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
    .ods-tooltip__popper.is-dark {
      max-width: 450px !important;
    }
  }
   ::v-deep &__classrow {
    margin: rem(32) rem(24) rem(32) rem(24);
    .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    .ods-button + .ods-button {
      margin-right: 10px;
      margin-left: 0px!important;
    }
   }

  ::v-deep div.d_icon {
    line-height: 23px !important;
    margin: -8px 0px !important;
    padding-right: 0px !important;
    &__popper {
      max-width: 450px !important;
    }
  }
  ::v-deep div.ods-tooltip__popper.is-dark {
      max-width: 450px;
  }
  .ods-tooltip__popper.is-dark {
      max-width: 450px;
  }
  ::v-deep &__popper {
    max-width: 450px !important;
  }
  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}
</style>
